import { NgClass } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';

import { AfTranslateDirective } from '@shared//modules/translate/directive/af-translate.directive';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';

@Component({
    selector: 'box-query-state',
    templateUrl: './box-query-state.component.html',
    standalone: true,
    imports: [AfTranslateDirective, NgClass]
})
export class BoxQueryStateComponent implements OnInit {
  boxQueryState: any = {
    actualState: {},
    states: [{state: 'initial'}, {state: 'in-process'}, {state: 'finished'}]
  }
  constructor(private translate: AfTranslateFactory) { }

  @Input() concept: any = null;

  ngOnInit(): void {
    let that: any = this.boxQueryState;
    that.actualState = {
      name: this.configureLiteralState(),
      // name: this.concept.processStates.current.alias? this.concept.processStates.current.alias : this.concept.processStates.current.name,
      state: this.configureProcessState()
    }
    that.states.forEach((state: any) => {
      state.active = false;
      if(that.actualState.state === state.state){
        state.active = true;
      }
    });
  }

  configureProcessState(){
    let processState: any = this.concept.processStates;
    if(!processState.previous){
      return 'initial';
    }else if(processState.current?.stateId0 > 3){
      return 'finished';
    }else{
      return 'in-process';
    }
  }

  configureLiteralState(){
    let literalState: any = this.concept.processStates.current;
    if (literalState.stateId0 > 3){
      return this.translate.instant('concept-instances-list.finished');
    } else {
      return literalState.name;
    }
  }
}

